module.exports = function fixWhitespace(s) {
  return typeof s === 'string' ? s.replace(/ +/g, ' ') : s;
};
